package com.essntl.uikit.components.link

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.isCtrlPressed
import androidx.compose.ui.input.key.isMetaPressed
import androidx.compose.ui.input.key.key
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.button.secondary.EsLargeSecondaryButton
import com.essntl.uikit.components.iconbutton.primary.EsLargePrimaryIconButton
import com.essntl.uikit.components.iconbutton.primary.EsMediumPrimaryIconButton
import com.essntl.uikit.components.iconbutton.primary.EsSmallPrimaryIconButton
import com.essntl.uikit.components.iconbutton.secondary.EsLargeSecondaryIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.icons.EsMediumIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.key.LocalKeyboardState

@Composable
fun NavLinkRow(
    items: List<NavLinkState>,
    onItemClicked: (index: Int, item: NavLinkState) -> Unit,
    modifier: Modifier = Modifier,
) {
    val keyboardState = LocalKeyboardState.current

    LaunchedEffect(keyboardState.pressedKey) {
        if (items.isNotEmpty())
            if (items.last().canRefresh) {
                val event = keyboardState.pressedKey ?: return@LaunchedEffect

                if (event.key == Key.R &&
                    (event.isCtrlPressed || event.isMetaPressed)
                )
                    items.last().onRefresh()
            }
    }

    Row(
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
        modifier = modifier.fillMaxWidth(),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            items.forEachIndexed { index, item ->
                NavLinkItem(
                    item = item,
                    onClick = {
                        onItemClicked(index, item)
                    },
                    enabled = index != items.lastIndex,
                )

                if (index != items.lastIndex)
                    NavLinkDivider()
            }
        }

        if (items.isNotEmpty())
            if (items.last().canRefresh)
                EsMediumPrimaryIconButton(
                    onClick = {
                        items
                            .last()
                            .onRefresh()
                    },
                    iconRes = EsIcons.Refresh,
                    modifier = Modifier
                        .padding(end = 8.dp)
                )

    }
}